import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { supabase } from "../utils/supabaseClient";
import {
  LayoutDashboard,
  Calendar,
  Users,
  Package,
  Factory,
  MapPin,
  LogOut,
  Info,
} from "lucide-react";
import "../styles/Dashboard.css";

const DashboardLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;

      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("user");
      navigate("/"); // Redirect to home page
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="dashboard-container">
      <nav className="side-nav">
        <div className="sidenav-brand">
          <Link to="/dashboard">
            <img
              src="/logo/new-logo.png"
              alt="Infinipoint Technologies"
              className="sidenav-logo-img"
            />
          </Link>
        </div>
        <div className="sidenav-items">
          <Link
            to="/dashboard"
            className={`sidenav-item ${isActive("/dashboard") ? "active" : ""}`}
          >
            <LayoutDashboard size={24} />
            <span>Dashboard</span>
          </Link>
          <Link
            to="/dashboard/webinars"
            className={`sidenav-item ${
              isActive("/dashboard/webinars") ? "active" : ""
            }`}
          >
            <Calendar size={24} />
            <span>Webinar Management</span>
          </Link>
          <Link
            to="/dashboard/partners"
            className={`sidenav-item ${
              isActive("/dashboard/partners") ? "active" : ""
            }`}
          >
            <Users size={24} />
            <span>Partner Management</span>
          </Link>
          <Link
            to="/dashboard/products"
            className={`sidenav-item ${
              isActive("/dashboard/products") ? "active" : ""
            }`}
          >
            <Package size={24} />
            <span>Product Management</span>
          </Link>
          <Link
            to="/dashboard/industries"
            className={`sidenav-item ${
              isActive("/dashboard/industries") ? "active" : ""
            }`}
          >
            <Factory size={24} />
            <span>Industries Management</span>
          </Link>
          <Link
            to="/dashboard/offices"
            className={`sidenav-item ${
              isActive("/dashboard/offices") ? "active" : ""
            }`}
          >
            <MapPin size={24} />
            <span>Regional and Branch Offices</span>
          </Link>
          <Link
            to="/dashboard/about"
            className={`sidenav-item ${
              isActive("/dashboard/about") ? "active" : ""
            }`}
          >
            <Info size={24} />
            <span>About</span>
          </Link>
        </div>
        <button onClick={handleLogout} className="sidenav-item logout-button">
          <LogOut size={24} />
          <span>Logout</span>
        </button>
      </nav>

      <main className="dashboard-content">{children}</main>
    </div>
  );
};

export default DashboardLayout;
